// src/components/common/PluginCardSkeleton.tsx
import React from 'react';

export function PluginCardSkeleton() {
    return (
        <div className="block bg-card-bg rounded-xl overflow-hidden shadow-subtle relative">
            {/* Overlay para o efeito de shimmer */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent z-10 animate-shimmer"></div>

            <div className="relative h-40 w-full bg-gray-200 flex items-center justify-center">
                {/* Ícone ou imagem placeholder */}
                <div className="w-20 h-20 bg-gray-300 rounded-md"></div>
            </div>

            <div className="p-4 border-t border-border-color">
                {/* Categoria placeholder */}
                <div className="h-3 w-1/3 bg-gray-200 rounded mb-2"></div>
                {/* Nome do plugin placeholder */}
                <div className="h-4 w-2/3 bg-gray-200 rounded"></div>
            </div>
        </div>
    );
}